<template>
  <div class="content-main-box" style="max-height: 380px; height: 100%">
    <el-table
      border
      stripe
      :max-height="300"
      :data="sliceData"
      @selection-change="tableSelectionChange"
      style="width: 940px"
    >
      <!-- selection -->
      <el-table-column
        type="selection"
        width="40"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="tenantName" label="指派公司" min-width="120">
      </el-table-column>
      <el-table-column prop="bizUnitName" label="核算单元" min-width="120">
      </el-table-column>
      <el-table-column prop="address" label="操作" width="140" v-if="!disabled">
        <template slot-scope="scope">
          <span
            class="delete-btn"
            @click="deletePeople(scope.row)"
            style="cursor: pointer"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="padding-top: 10px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next,jumper"
      :total="page.totalRows"
      :pager-count="5"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "BizUnitTable",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalRows: 0,
      },
      sliceData: [],
    };
  },
  methods: {
    deletePeople(row) {
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("delete-item", row.bizUnitGuid);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    tableSelectionChange(val) {
      this.$emit("selection-change", val || []);
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.handlePage();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.handlePage();
    },
    handlePage() {
      this.page.totalRows = this.tableData.length;
      let { pageIndex, pageSize, totalRows } = this.page;
      // 计算分页总数
      const start = (pageIndex - 1) * pageSize;
      const end = pageIndex * pageSize;

      // 返回分页数据
      this.sliceData = this.tableData.slice(start, end);
    },
  },
  computed: {
    disabled() {
      // !查看模式
      return this.$route.query.operationMode === 'look';
    },
  },
  watch: {
    tableData: {
      handler(val) {
        this.handlePage();
      },
      deep: true,
    },
  },
  created() {
    this.handlePage();
  },
};
</script>

<style lang="less" scoped>
.delete-btn {
  color: #4fa1a4;
  font-size: 14px;
  margin-right: 10px;
}
</style>
